import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/tmp/build/80754af9/repo/apps/quales-web/components/utils/approuterconfig/ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextIntlProvider"] */ "/tmp/build/80754af9/repo/apps/quales-web/components/utils/approuterconfig/IntlProvider.tsx");
